import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './ot-io-t-security.css'

const OTIoTSecurity = (props) => {
  return (
    <div className="ot-io-t-security-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="OT-IoT-Security - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/ot-io-t-security"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="ot---iot-security-hero-section hero-section">
        <div className="hero-media-wrapper">
          <img
            alt="High-tech robots assembling a car in a modern factory setting, showcasing automation."
            src="https://images.pexels.com/photos/19233057/pexels-photo-19233057.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-background-media"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-block">
          <div className="ot---iot-security-hero-content-inner">
            <h1 className="hero-title ot---iot-security-hero-title">
              {' '}
              IoT Security
            </h1>
            <p className="ot---iot-security-hero-subtitle hero-subtitle">
              Protect your operational technology and IoT ecosystems with
              enterprise-grade security controls, continuous monitoring, and
              industry-aligned risk mitigation strategies.
            </p>
            <div className="hero-cta-group ot---iot-security-hero-cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#approach">
                <div className="btn btn-lg btn-outline">
                  <span>Learn Our Approach</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="threat-landscape-section">
        <div className="threat-landscape-container">
          <div className="threat-landscape-header">
            <h2 className="section-title"> IoT Threat Landscape</h2>
            <p className="section-subtitle">
              Understanding the critical risks facing operational technology and
              IoT infrastructure in 2025
            </p>
          </div>
          <div className="threat-landscape-grid">
            <article className="threat-card">
              <div className="threat-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="threat-card-title">Ransomware Targeting ICS</h3>
              <p className="threat-card-description">
                Industrial control systems face increasing ransomware attacks
                that can halt production, compromise safety systems, and cause
                millions in operational downtime and recovery costs.
              </p>
            </article>
            <article className="threat-card">
              <div className="threat-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="threat-card-title">
                Unsecured Network Segmentation
              </h3>
              <p className="threat-card-description">
                Lack of proper network segmentation between IT and OT
                environments creates pathways for lateral movement, allowing
                cyber threats to propagate from corporate networks to critical
                infrastructure.
              </p>
            </article>
            <article className="threat-card">
              <div className="threat-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10 12h4m-4 5h4M10 7h4m4 5h2m-2 6h2M18 6h2M4 12h2m-2 6h2M4 6h2"></path>
                    <rect x="6" y="2" rx="2" width="12" height="20"></rect>
                  </g>
                </svg>
              </div>
              <h3 className="threat-card-title">IoT Device Vulnerabilities</h3>
              <p className="threat-card-description">
                IoT devices often ship with default credentials, unpatched
                firmware, and minimal security controls, making them prime
                targets for botnet recruitment and network infiltration.
              </p>
            </article>
            <article className="threat-card">
              <div className="threat-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="threat-card-title">Supply Chain Compromise</h3>
              <p className="threat-card-description">
                Adversaries compromise hardware and firmware during
                manufacturing or distribution phases, embedding backdoors that
                provide persistent access to OT and IoT environments.
              </p>
            </article>
            <article className="threat-card">
              <div className="threat-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                  </g>
                </svg>
              </div>
              <h3 className="threat-card-title">Legacy System Exposure</h3>
              <p className="threat-card-description">
                Aging OT systems running outdated operating systems and
                protocols lack modern security features, cannot be easily
                patched, and remain vulnerable to well-known exploits.
              </p>
            </article>
            <article className="threat-card">
              <div className="threat-card-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="threat-card-title">
                Insider Threats &amp; Misconfigurations
              </h3>
              <p className="threat-card-description">
                Privileged access misuse, accidental misconfigurations, and
                inadequate change management processes can introduce
                vulnerabilities or enable malicious insiders to sabotage
                operations.
              </p>
            </article>
          </div>
        </div>
      </section>
      <section className="iot-controls-section">
        <div className="iot-controls-container">
          <div className="iot-controls-header">
            <h2 className="section-title">IoT Security Controls</h2>
            <p className="section-subtitle">
              Industry-aligned security hardening and controls for IoT device
              ecosystems
            </p>
          </div>
          <div className="iot-controls-grid">
            <article className="control-card">
              <div className="control-card-header">
                <div className="control-card-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="11"
                        rx="2"
                        ry="2"
                        width="18"
                        height="11"
                      ></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="control-card-title">Device Authentication</h3>
              </div>
              <p className="control-card-description">
                Implement certificate-based authentication, eliminate default
                credentials, and enforce unique device identities with
                cryptographic validation for all IoT endpoints.
              </p>
              <ul className="control-card-list">
                <li className="control-card-list-item">
                  <span>X.509 certificate provisioning</span>
                </li>
                <li className="control-card-list-item">
                  <span>Hardware root of trust integration</span>
                </li>
                <li className="control-card-list-item">
                  <span>Multi-factor device enrollment</span>
                </li>
              </ul>
            </article>
            <article className="control-card">
              <div className="control-card-header">
                <div className="control-card-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="control-card-title">Firmware Security</h3>
              </div>
              <p className="control-card-description">
                Establish secure firmware update mechanisms with cryptographic
                signing, rollback protection, and automated vulnerability
                scanning throughout the device lifecycle.
              </p>
              <ul className="control-card-list">
                <li className="control-card-list-item">
                  <span>Signed firmware validation</span>
                </li>
                <li className="control-card-list-item">
                  <span>Over-the-air update encryption</span>
                </li>
                <li className="control-card-list-item">
                  <span>Version rollback prevention</span>
                </li>
              </ul>
            </article>
            <article className="control-card">
              <div className="control-card-header">
                <div className="control-card-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                      <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="control-card-title">
                  Network Micro-Segmentation
                </h3>
              </div>
              <p className="control-card-description">
                Deploy VLAN segmentation, firewall policies, and zero-trust
                network access to isolate IoT devices and limit blast radius in
                case of compromise.
              </p>
              <ul className="control-card-list">
                <li className="control-card-list-item">
                  <span>Device-specific VLANs</span>
                </li>
                <li className="control-card-list-item">
                  <span>East-west traffic filtering</span>
                </li>
                <li className="control-card-list-item">
                  <span>Application-layer gateways</span>
                </li>
              </ul>
            </article>
            <article className="control-card">
              <div className="control-card-header">
                <div className="control-card-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="8" cx="11" cy="11"></circle>
                      <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="control-card-title">Continuous Monitoring</h3>
              </div>
              <p className="control-card-description">
                Implement real-time behavioral analytics, anomaly detection, and
                SIEM integration to identify suspicious activity and
                unauthorized device communications.
              </p>
              <ul className="control-card-list">
                <li className="control-card-list-item">
                  <span>Traffic pattern analysis</span>
                </li>
                <li className="control-card-list-item">
                  <span>Device behavior baselines</span>
                </li>
                <li className="control-card-list-item">
                  <span>Automated alert correlation</span>
                </li>
              </ul>
            </article>
            <article className="control-card">
              <div className="control-card-header">
                <div className="control-card-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M10 12h4m-4 5h4M10 7h4m4 5h2m-2 6h2M18 6h2M4 12h2m-2 6h2M4 6h2"></path>
                      <rect x="6" y="2" rx="2" width="12" height="20"></rect>
                    </g>
                  </svg>
                </div>
                <h3 className="control-card-title">Secure Boot &amp; TPM</h3>
              </div>
              <p className="control-card-description">
                Leverage hardware security modules and trusted platform modules
                to ensure device integrity at boot and runtime, preventing
                unauthorized firmware modifications.
              </p>
              <ul className="control-card-list">
                <li className="control-card-list-item">
                  <span>Boot chain verification</span>
                </li>
                <li className="control-card-list-item">
                  <span>Hardware attestation</span>
                </li>
                <li className="control-card-list-item">
                  <span>Secure enclave utilization</span>
                </li>
              </ul>
            </article>
            <article className="control-card">
              <div className="control-card-header">
                <div className="control-card-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zM9 12h6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="control-card-title">Data Encryption</h3>
              </div>
              <p className="control-card-description">
                Enforce end-to-end encryption for data in transit and at rest
                using TLS 1.3, secure key management, and hardware-backed
                encryption where available.
              </p>
              <ul className="control-card-list">
                <li className="control-card-list-item">
                  <span>TLS 1.3+ for communications</span>
                </li>
                <li className="control-card-list-item">
                  <span>AES-256 at-rest encryption</span>
                </li>
                <li className="control-card-list-item">
                  <span>Key rotation automation</span>
                </li>
              </ul>
            </article>
          </div>
        </div>
      </section>
      <section className="ot-controls-section">
        <div className="ot-controls-container">
          <div className="ot-controls-header">
            <h2 className="section-title">Operational Technology Controls</h2>
            <p className="section-subtitle">
              OT-specific security measures for segmentation, monitoring, and
              operational resilience
            </p>
          </div>
          <div className="ot-controls-grid">
            <article className="ot-control-card">
              <div className="ot-control-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <div className="ot-control-content">
                <h3 className="ot-control-title">IT/OT Network Segmentation</h3>
                <p className="ot-control-description">
                  Establish demilitarized zones between corporate IT and OT
                  networks using industrial firewalls, unidirectional gateways,
                  and data diodes to prevent lateral threat movement.
                </p>
              </div>
            </article>
            <article className="ot-control-card">
              <div className="ot-control-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.34-4.34"></path>
                  </g>
                </svg>
              </div>
              <div className="ot-control-content">
                <h3 className="ot-control-title">
                  Asset Discovery &amp; Inventory
                </h3>
                <p className="ot-control-description">
                  Deploy passive network monitoring and protocol analysis to
                  maintain real-time visibility of all OT assets, including
                  PLCs, SCADA systems, HMIs, and industrial protocols.
                </p>
              </div>
            </article>
            <article className="ot-control-card">
              <div className="ot-control-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="ot-control-content">
                <h3 className="ot-control-title">Protocol Whitelisting</h3>
                <p className="ot-control-description">
                  Implement allow-listing for industrial protocols such as
                  Modbus, DNP3, and OPC-UA, blocking unauthorized protocol usage
                  and preventing protocol exploitation attacks.
                </p>
              </div>
            </article>
            <article className="ot-control-card">
              <div className="ot-control-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <div className="ot-control-content">
                <h3 className="ot-control-title">Access Control &amp; MFA</h3>
                <p className="ot-control-description">
                  Enforce least-privilege access policies with multi-factor
                  authentication, privileged access management, and role-based
                  controls for engineering workstations and operator consoles.
                </p>
              </div>
            </article>
            <article className="ot-control-card">
              <div className="ot-control-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="ot-control-content">
                <h3 className="ot-control-title">
                  Anomaly Detection &amp; IDS
                </h3>
                <p className="ot-control-description">
                  Deploy OT-aware intrusion detection systems with behavioral
                  baselines, anomaly detection, and signature-based threat
                  identification tailored for industrial environments.
                </p>
              </div>
            </article>
            <article className="ot-control-card">
              <div className="ot-control-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10 12h4m-4 5h4M10 7h4m4 5h2m-2 6h2M18 6h2M4 12h2m-2 6h2M4 6h2"></path>
                    <rect x="6" y="2" rx="2" width="12" height="20"></rect>
                  </g>
                </svg>
              </div>
              <div className="ot-control-content">
                <h3 className="ot-control-title">
                  Patch &amp; Vulnerability Management
                </h3>
                <p className="ot-control-description">
                  Establish risk-based patching workflows with offline testing,
                  virtual patching, and compensating controls for legacy systems
                  that cannot be updated without operational impact.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section id="approach" className="approach-section">
        <div className="approach-container">
          <div className="approach-header">
            <h2 className="section-title">Our Risk Assessment Approach</h2>
            <p className="section-subtitle">
              A structured methodology for OT/IoT risk assessment, scoring, and
              prioritization
            </p>
          </div>
          <div className="approach-steps">
            <article className="approach-step">
              <div className="approach-step-number">
                <span>01</span>
              </div>
              <div className="approach-step-content">
                <h3 className="approach-step-title">
                  Discovery &amp; Asset Inventory
                </h3>
                <p className="approach-step-description">
                  Passive network scanning and protocol analysis to identify all
                  OT/IoT assets, communication patterns, and device dependencies
                  without disrupting operations.
                </p>
              </div>
            </article>
            <article className="approach-step">
              <div className="approach-step-number">
                <span>02</span>
              </div>
              <div className="approach-step-content">
                <h3 className="approach-step-title">
                  Vulnerability Assessment
                </h3>
                <p className="approach-step-description">
                  Comprehensive vulnerability scanning using OT-safe tools, CVE
                  correlation, firmware analysis, and configuration review to
                  identify exploitable weaknesses.
                </p>
              </div>
            </article>
            <article className="approach-step">
              <div className="approach-step-number">
                <span>03</span>
              </div>
              <div className="approach-step-content">
                <h3 className="approach-step-title">Threat Modeling</h3>
                <p className="approach-step-description">
                  Map attack vectors, threat actors, and exploitation scenarios
                  specific to your industrial environment, considering both
                  cyber and physical security implications.
                </p>
              </div>
            </article>
            <article className="approach-step">
              <div className="approach-step-number">
                <span>04</span>
              </div>
              <div className="approach-step-content">
                <h3 className="approach-step-title">
                  Risk Scoring &amp; Prioritization
                </h3>
                <p className="approach-step-description">
                  Apply CVSS scoring, business impact analysis, and operational
                  criticality weighting to prioritize risks based on likelihood,
                  consequence, and remediation feasibility.
                </p>
              </div>
            </article>
            <article className="approach-step">
              <div className="approach-step-number">
                <span>05</span>
              </div>
              <div className="approach-step-content">
                <h3 className="approach-step-title">Mitigation Roadmap</h3>
                <p className="approach-step-description">
                  Develop actionable remediation plans with timelines, owner
                  assignments, compensating controls, and phased implementation
                  strategies aligned with operational windows.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section className="mitigation-timeline-section">
        <div className="mitigation-timeline-wrapper">
          <div className="mitigation-timeline-header">
            <h2 className="section-title">Mitigation Timeline</h2>
            <p className="section-subtitle">
              Actionable steps with timelines and owner mapping to
              systematically reduce OT/IoT security risk
            </p>
          </div>
          <div className="mitigation-timeline-track">
            <article className="ot---iot-security-timeline-event">
              <div className="ot---iot-security-timeline-event-marker"></div>
              <div className="ot---iot-security-timeline-event-content">
                <div className="timeline-event-phase">
                  <span>Phase 1: Immediate</span>
                </div>
                <h3 className="ot---iot-security-timeline-event-title">
                  Critical Vulnerability Remediation
                </h3>
                <p className="ot---iot-security-timeline-event-description">
                  Address critical CVEs with active exploits, eliminate default
                  credentials, disable unnecessary services, and implement
                  emergency access controls.
                </p>
                <div className="timeline-event-meta">
                  <span className="timeline-event-duration">Weeks 1-2</span>
                  <span className="timeline-event-owner">
                    IT Security Team &amp; OT Engineers
                  </span>
                </div>
              </div>
            </article>
            <article className="ot---iot-security-timeline-event">
              <div className="ot---iot-security-timeline-event-marker"></div>
              <div className="ot---iot-security-timeline-event-content">
                <div className="timeline-event-phase">
                  <span>Phase 2: Short-term</span>
                </div>
                <h3 className="ot---iot-security-timeline-event-title">
                  Network Segmentation Deployment
                </h3>
                <p className="ot---iot-security-timeline-event-description">
                  Deploy industrial firewalls, establish DMZs between IT/OT,
                  implement VLAN segmentation, and configure protocol filtering
                  at network boundaries.
                </p>
                <div className="timeline-event-meta">
                  <span className="timeline-event-duration">Weeks 3-8</span>
                  <span className="timeline-event-owner">
                    Network Engineering &amp; OT Operations
                  </span>
                </div>
              </div>
            </article>
            <article className="ot---iot-security-timeline-event">
              <div className="ot---iot-security-timeline-event-marker"></div>
              <div className="ot---iot-security-timeline-event-content">
                <div className="timeline-event-phase">
                  <span>Phase 3: Medium-term</span>
                </div>
                <h3 className="ot---iot-security-timeline-event-title">
                  Monitoring &amp; Detection Systems
                </h3>
                <p className="ot---iot-security-timeline-event-description">
                  Deploy OT-aware IDS/IPS, integrate SIEM logging, establish
                  behavioral baselines, and configure automated alerting for
                  anomaly detection.
                </p>
                <div className="timeline-event-meta">
                  <span className="timeline-event-duration">Months 3-4</span>
                  <span className="timeline-event-owner">
                    SOC Team &amp; OT Security Architect
                  </span>
                </div>
              </div>
            </article>
            <article className="ot---iot-security-timeline-event">
              <div className="ot---iot-security-timeline-event-marker"></div>
              <div className="ot---iot-security-timeline-event-content">
                <div className="timeline-event-phase">
                  <span>Phase 4: Long-term</span>
                </div>
                <h3 className="ot---iot-security-timeline-event-title">
                  Authentication &amp; Access Modernization
                </h3>
                <p className="ot---iot-security-timeline-event-description">
                  Implement certificate-based authentication, deploy PAM
                  solutions, enforce MFA for privileged access, and establish
                  zero-trust access policies.
                </p>
                <div className="timeline-event-meta">
                  <span className="timeline-event-duration">Months 5-6</span>
                  <span className="timeline-event-owner">
                    Identity Management &amp; OT Security
                  </span>
                </div>
              </div>
            </article>
            <article className="ot---iot-security-timeline-event">
              <div className="ot---iot-security-timeline-event-marker"></div>
              <div className="ot---iot-security-timeline-event-content">
                <div className="timeline-event-phase">
                  <span>Phase 5: Continuous</span>
                </div>
                <h3 className="ot---iot-security-timeline-event-title">
                  Governance &amp; Continuous Improvement
                </h3>
                <p className="ot---iot-security-timeline-event-description">
                  Establish patch management processes, conduct quarterly
                  assessments, perform tabletop exercises, and maintain
                  compliance with IEC 62443 and NIST frameworks.
                </p>
                <div className="timeline-event-meta">
                  <span className="timeline-event-duration">Ongoing</span>
                  <span className="timeline-event-owner">
                    CISO &amp; Compliance Officer
                  </span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section className="ot---iot-security-standards-section">
        <div className="ot---iot-security-standards-container">
          <div className="ot---iot-security-standards-header">
            <h2 className="section-title">
              Standards &amp; Compliance Mapping
            </h2>
            <p className="section-subtitle">
              Alignment with IEC 62443, NIST SP 800-82, and industry-recognized
              OT/IoT security frameworks
            </p>
          </div>
          <div className="ot---iot-security-standards-table-wrapper">
            <table className="ot---iot-security-standards-table">
              <thead>
                <tr>
                  <th className="standards-table-header">
                    <span>Standard / Framework</span>
                  </th>
                  <th className="standards-table-header">
                    <span>Applicable Domain</span>
                  </th>
                  <th className="standards-table-header">
                    <span>Key Requirements</span>
                  </th>
                  <th className="standards-table-header">
                    <span>Cysigil Security Coverage</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="standards-table-row">
                  <td className="standards-table-cell">
                    <div className="standards-table-standard">
                      <span>IEC 62443</span>
                    </div>
                  </td>
                  <td className="standards-table-cell">
                    <span>
                      Industrial Automation &amp; Control Systems (IACS)
                    </span>
                  </td>
                  <td className="standards-table-cell">
                    <span>
                      Network segmentation, access control, system integrity,
                      data confidentiality, restricted data flow, and timely
                      response to events
                    </span>
                  </td>
                  <td className="standards-table-cell">
                    <span className="coverage-full coverage-badge">
                      Full Coverage
                    </span>
                  </td>
                </tr>
                <tr className="standards-table-row">
                  <td className="standards-table-cell">
                    <div className="standards-table-standard">
                      <span>NIST SP 800-82</span>
                    </div>
                  </td>
                  <td className="standards-table-cell">
                    <span>ICS Security (SCADA, DCS, PLC)</span>
                  </td>
                  <td className="standards-table-cell">
                    <span>
                      Risk assessment, security policies, network architecture,
                      access controls, incident response, and continuous
                      monitoring
                    </span>
                  </td>
                  <td className="standards-table-cell">
                    <span className="coverage-full coverage-badge">
                      Full Coverage
                    </span>
                  </td>
                </tr>
                <tr className="standards-table-row">
                  <td className="standards-table-cell">
                    <div className="standards-table-standard">
                      <span>NIST Cybersecurity Framework</span>
                    </div>
                  </td>
                  <td className="standards-table-cell">
                    <span>Cross-domain (IT, OT, IoT)</span>
                  </td>
                  <td className="standards-table-cell">
                    <span>
                      Identify, Protect, Detect, Respond, Recover functions
                      across asset management, data security, and resilience
                    </span>
                  </td>
                  <td className="standards-table-cell">
                    <span className="coverage-full coverage-badge">
                      Full Coverage
                    </span>
                  </td>
                </tr>
                <tr className="standards-table-row">
                  <td className="standards-table-cell">
                    <div className="standards-table-standard">
                      <span>ISA/IEC 62443-4-2</span>
                    </div>
                  </td>
                  <td className="standards-table-cell">
                    <span>Component-level Security for IACS</span>
                  </td>
                  <td className="standards-table-cell">
                    <span>
                      Secure development lifecycle, authentication,
                      cryptography, malware protection, and data integrity for
                      control system components
                    </span>
                  </td>
                  <td className="standards-table-cell">
                    <span className="coverage-high coverage-badge">
                      High Coverage
                    </span>
                  </td>
                </tr>
                <tr className="standards-table-row">
                  <td className="standards-table-cell">
                    <div className="standards-table-standard">
                      <span>ISO/IEC 27001</span>
                    </div>
                  </td>
                  <td className="standards-table-cell">
                    <span>Information Security Management Systems</span>
                  </td>
                  <td className="standards-table-cell">
                    <span>
                      Risk management, security controls (Annex A), continuous
                      improvement, and compliance audit trails
                    </span>
                  </td>
                  <td className="standards-table-cell">
                    <span className="coverage-full coverage-badge">
                      Full Coverage
                    </span>
                  </td>
                </tr>
                <tr className="standards-table-row">
                  <td className="standards-table-cell">
                    <div className="standards-table-standard">
                      <span>NERC CIP</span>
                    </div>
                  </td>
                  <td className="standards-table-cell">
                    <span>Electric Sector Critical Infrastructure</span>
                  </td>
                  <td className="standards-table-cell">
                    <span>
                      Physical security, electronic perimeters, incident
                      reporting, recovery plans, and personnel security for bulk
                      electric systems
                    </span>
                  </td>
                  <td className="standards-table-cell">
                    <span className="coverage-advisory coverage-badge">
                      Advisory Support
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section
        id="contact"
        className="cta-section ot---iot-security-cta-section"
      >
        <div className="cta-container">
          <div className="ot---iot-security-cta-card">
            <div className="ot---iot-security-cta-icon-wrapper">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="ot---iot-security-cta-content">
              <h2 className="section-title">Secure Your IoT Infrastructure</h2>
              <p className="section-content">
                Partner with Cysigil Security to assess, harden, and continuously
                monitor your operational technology and IoT ecosystems. Our
                experts bring deep industrial security expertise and proven
                methodologies aligned with IEC 62443, NIST SP 800-82, and
                industry best practices.
              </p>
            </div>
            <div className="ot---iot-security-cta-actions">
              <a href="#request-assessment">
                <div className="btn-primary btn-xl btn">
                  <span>Request IoT Assessment</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="ot-io-t-security-container2">
        <div className="ot-io-t-security-container3">
          <Script
            html={`<script defer data-name="ot-iot-security-page">
(function(){
  const timelineTrack = document.querySelector(".mitigation-timeline-track")
  const caseStudiesRail = document.querySelector(".case-studies-rail")

  if (timelineTrack) {
    timelineTrack.addEventListener("wheel", (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault()
        timelineTrack.scrollLeft += e.deltaY
      }
    })
  }

  if (caseStudiesRail) {
    caseStudiesRail.addEventListener("wheel", (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault()
        caseStudiesRail.scrollLeft += e.deltaY
      }
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default OTIoTSecurity
